import { render, staticRenderFns } from "./Minutely.vue?vue&type=template&id=235b40ed&scoped=true"
import script from "./Minutely.vue?vue&type=script&lang=js"
export * from "./Minutely.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b40ed",
  null
  
)

export default component.exports